import React, { useEffect, useMemo, useState } from "react";
import { Checkbox, DatePicker, Form, Input, Row, Icon, Popconfirm } from "antd";
import noticeTypes from "../../../../constants/noticeTypes";
import { useDispatch, useSelector } from "react-redux";
import {
	createNoticeSetting,
	createNoticeSettings,
	createNoticeTypeSettings,
} from "../../../../store/actions/actions";
import moment from "moment";
import dateStartNamesForTypes from "../../../../constants/dateStartNamesForTypes";

const Wrapper = ({ children, disabled, setDateForceEnabled }) => {
	if (disabled) {
		return (
			<Popconfirm
				onConfirm={() => {
					setDateForceEnabled(true);
				}}
				title="После редактирования дата применится к другим типам оповещения"
			>
				<div>{children}</div>
			</Popconfirm>
		);
	} else {
		return <>{children}</>;
	}
};

const isDisabledCheck = (createNotice, start) => {
	return !!Object.entries(createNotice)?.filter(([key, value]) => {
		if (key === "StartEmail" || key === "StartPush" || key === "StartPhone") {
			if (start && value && !moment(value)?.isSame(start, "minute")) {
				return true;
			}
		}
		return false;
	}).length;
};
const EntryPage = ({ setChosenNoticeTypes, chosenNoticeTypes }) => {
	const dispatch = useDispatch();
	const createNotice = useSelector(
		(store) => store.debtsStore.createNotice
	);
	const { title, start } = createNotice || {};

	const [dateForceEnabled, setDateForceEnabled] = useState(false);

	const dateDisabled = useMemo(
		() => !dateForceEnabled && isDisabledCheck(createNotice, start),
		[dateForceEnabled, chosenNoticeTypes, createNotice, start]
	);

	return (
		<>
			<Row type="flex" justify="space-between" className="typesRow">
				{noticeTypes.map((noticeType) => {
					return (
						<Checkbox
							onChange={(e) => {
								setChosenNoticeTypes({
									...chosenNoticeTypes,
									[noticeType.typeName]: e.target.checked,
								});
							}}
							checked={chosenNoticeTypes[noticeType.typeName]}
						>
							{noticeType.name}
						</Checkbox>
					);
				})}
			</Row>
			<Form.Item
				colon={false}
				label="Заголовок"
				validateStatus={title?.length === 60 ? "warning" : ""}
				help={title?.length === 60 ? "Достигнут максимум в 60 символов" : ""}
			>
				<Input
					placeholder="Тема оповещения"
					onChange={(e) =>
						dispatch(createNoticeSettings({ title: e.target.value }))
					}
					maxLength={60}
					value={title}
				/>
			</Form.Item>

			<Form.Item
				colon={false}
				label="Старт оповещения"
				help={
					dateDisabled ? "Дата начала была изменена для отдельных типов" : ""
				}
			>
				<Wrapper
					disabled={dateDisabled}
					setDateForceEnabled={setDateForceEnabled}
				>
					<DatePicker
						showTime={{ format: 'HH:mm' }}
						disabledDate={(date) => {
							return !date.isAfter(moment()) && !date.isSame(moment(), "day");
						}}
						placeholder="Дата и время"
						className={
							dateDisabled ? "period_input disabled_input" : "period_input"
						}
						suffixIcon={<Icon type="calendar" style={{ color: "black" }} />}
						format="DD.MM.YYYY HH:mm"
						value={start}
						onChange={(e) => {
							dispatch(createNoticeSettings({ start: moment(e) }));
							Object.keys(chosenNoticeTypes).forEach(
								(chosenNoticeType) => {
									if (
										createNotice[
											dateStartNamesForTypes[chosenNoticeType]
										]
									) {
										dispatch(
											createNoticeSetting({
												[dateStartNamesForTypes[chosenNoticeType]]: "",
											})
										);
									}
								}
							);
							setDateForceEnabled(false);
						}}
						disabled={dateDisabled}
					/>
				</Wrapper>
			</Form.Item>
		</>
	);
};

export default EntryPage;
